import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component,
  OnInit, EventEmitter, Output, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { Router, ActivatedRoute, NavigationEnd, RouterOutlet } from '@angular/router';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';


import { Observable, merge } from 'rxjs';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/operator/merge';

import { rightPanelNavs } from './right-panel-navs';
import { brandInformationRoutes } from '../brand-information/brand-information.routes';
import { accountInformationRoutes } from '../account-information/account-information.routes';
import { BRAND_NAME, TRADE_INFO_NAME } from '../account-information/variables';
import { setUnreadCommentsCount } from 'shared/comments/comments-helpers';
import { TermsWidgetComponent } from 'shared/terms/terms-widget/terms-widget.component';

import { SegmentNavigationPageComponent } from '../_segment-navigation-page.component';
import { BeforeSaveModalComponent } from '../before-save-modal/before-save-modal.component';
import { DefaultModalComponent } from 'shared/modal/default-modal/default-modal.component';
import { DynamicNavsComponent } from 'shared/nav/dynamic-navs/dynamic-navs.component';
import { ErrorModalComponent } from 'shared/modal/error-modal/error-modal.component';

import { GlobalValidationService } from 'shared/global-validation/global-validation.service';
import { BrandService } from 'shared/brand/brand.service';
import { InformationPageService } from './information-page.service';
import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { CommentsService } from 'shared/comments/comments.service';
import {takeWhile} from 'rxjs/operators';
import {ProductPanelComponent} from '../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'sd-information-page',
  templateUrl: 'information-page.component.html',
  styleUrls: ['information-page.component.scss'],
  providers: [SegmentValidationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationPageComponent extends SegmentNavigationPageComponent implements OnInit {

  rightPanelNavs: Array<any>;
  updatePublishedCatalog: boolean = false;
  itemsCount: Number = 1000; // stub for items count
  currentSegment: string = '';
  isSaveBeforeLeaving: boolean = false;
  errorModalTitle: string = '';
  pageRoute: string = ''; // global or account
  segmentsNavMarginLeft: number = 145;

  protected isPageActive: boolean = true;

  @ViewChild('beforeSaveModal', {static: false})
  private beforeSaveModal: BeforeSaveModalComponent | void;

  @ViewChild(RouterOutlet, {static: false})
  private routerOutlet: RouterOutlet | void;

  @ViewChild('saveBeforeLeaving', {static: false})
  private saveBeforeLeaving: DefaultModalComponent | void;

  @ViewChild('errorModal', {static: false})
  private errorModal: ErrorModalComponent | void;

  @ViewChild(DynamicNavsComponent, {static: true})
  private dynamicNavs: DynamicNavsComponent | void;

  @ViewChild(TermsWidgetComponent, {static: false})
  private termsWidget: TermsWidgetComponent | void;

  private updatePublishedRoutes: Array<String>;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    private informationPageService: InformationPageService,
    private globalValidationService: GlobalValidationService,
    private brandService: BrandService,
    private commentsService: CommentsService,
    protected permissionsService: PermissionsService,
    protected ref: ChangeDetectorRef,
  ) {
    super(router, route);
    this.informationPageService.itemsCountChanged
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((event: any) => {
      this.onItemsCountChanged(event);
    });

    // segment data was saved - need to refresh segments validation
    this.informationPageService.saved
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe(() => {
      this.updateGlobalValidations();
    });
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.informationPageService.showBeforeLeavingModal
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((event: any) => {
      this.showBeforeLeavingModal(true);
    });
    this.informationPageService.showBeforeSaveModal
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((event: any) => {
      this.onSaveClick();
    });
    this.pageRoute = _.get(this.route.snapshot, 'data.page.link');
    this.setUpdatePublishedRoutes();
    this.onRouteChange(null as any);
    _.defer(() => this.subscribeNavsChange());
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get showActionPanel(): boolean {
    return this.routerOutlet && this.routerOutlet.isActivated
    ? (<any>this.routerOutlet.component).showActionPanel
    : false;
  }

  get isDirty(): boolean {
    return this.routerOutlet && this.routerOutlet.isActivated
    ? (<any>this.routerOutlet.component).isDirty
    : false;
  }

  get isValid(): boolean {
    return this.routerOutlet && this.routerOutlet.isActivated
    ? (<any>this.routerOutlet.component).isValid
    : true;
  }

  get showUpdatePublished(): boolean {
    return _.includes(this.updatePublishedRoutes, this.currentSegment);
  }

  get updatePublished(): boolean {
    return !this.showUpdatePublished || !this.beforeSaveModal ? false : this.beforeSaveModal.updatePublished;
  }

  get showPublishAction(): boolean {
    return this.routerOutlet && this.routerOutlet.isActivated
    ? (<any>this.routerOutlet.component).showPublishAction
    : false;
  }

  get isAllowedToSave(): boolean {
    return this.routerOutlet && this.routerOutlet.isActivated ?
      (<any>this.routerOutlet.component).isAllowedToSave :
      true;
  }

  get brandId(): string|null {
    return this.brandService.getBrand();
  }

  get isBrandInformation(): boolean {
    return this.pageRoute === 'global-brand-information' ||
      _.includes([BRAND_NAME, TRADE_INFO_NAME], this.currentSegment);
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  applyPermissions(menu: any) {
    return _.filter(menu, (menuItem: any) => {
      if (!menuItem.allow || this.permissionsService.hasPermission(menuItem.allow) ) {
        return true;
      } else {
        return false;
      }
    });
  }

  /*******************************************
   * COMPONENT EVENT HANDLERS
   *******************************************/

  onRouteChange(event: NavigationEnd) {
    this.updateSegments();
    this.updateGlobalValidations();
    this.updateRightNavs();
  }

  onSaveBeforeLeaving(action: string) {
    switch (action) {
      case 'save':
        // check form errors before saving modal show
        if (this.showError()) {
          this.navigateToCurrentSegment();
          return this.saveBeforeLeaving && this.saveBeforeLeaving.hide();
        }

        this.isSaveBeforeLeaving = true;
        this.showBeforeSaveModal();
        break;
      // dont leave
      case 'cancel':
        this.navigateToCurrentSegment();
        return this.saveBeforeLeaving && this.saveBeforeLeaving.hide();
      // dont save
      default:
        this.isSaveBeforeLeaving = false;
        this.informationPageService.setCanDeactivate(true);
    }
    this.showBeforeLeavingModal(false);
  }

  onSaveClick() {
    // check form errors before saving modal show
    if (this.showError() || !this.isAllowedToSave) { return; }

    this.showBeforeSaveModal();
  }

  onCancelClick() {
    this.informationPageService.emitCancel(this.currentSegment);
  }

  onPublishClick() {
    // save with update published
    this.save(true);
  }

  onModalCancel() {
    if (this.isSaveBeforeLeaving) {
      this.showBeforeLeavingModal(true);
    }
  }

  onModalConfirm(event: any) {
    this.save(event);
  }

  onItemsCountChanged(event: any) {
    this.itemsCount = event;
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/

  private showBeforeLeavingModal(show: boolean = true) {
    if (!this.saveBeforeLeaving) {
      return;
    }
    if (show) {
      this.saveBeforeLeaving.show();
    } else {
      this.saveBeforeLeaving.hide();
    }
  }

  private showBeforeSaveModal() {
    if (!this) { return; }
    if (this.pageRoute === 'global-brand-information' ||
      _.includes([BRAND_NAME, TRADE_INFO_NAME], this.currentSegment)) {
      this.informationPageService.emitSaveModal();
      if (this.beforeSaveModal) {
        this.beforeSaveModal.show();
      }
    } else {
      this.save();
    }
  }

  private navigateToCurrentSegment() {
    if (this.segmentsNavigation) {
      this.segmentsNavigation.setActive(this.currentSegment);
    }
    this.informationPageService.setCanDeactivate(false);
    this.ref.markForCheck();
  }

  private showError(): boolean {
    if (this.routerOutlet && (<any>this.routerOutlet.component).getError) {
      this.errorModalTitle = (<any>this.routerOutlet.component).getError();
      if (this.errorModalTitle && this.errorModalTitle.length) {
        if (this.errorModal) {
          this.errorModal.show();
        }
        return true;
      }
    }
    return false;
  }

  private setUpdatePublishedRoutes() {
    let pageRoutes: any = [];
    switch (this.pageRoute) {
      case 'global-brand-information':
        pageRoutes = brandInformationRoutes;
        break;
      case 'account-information':
        pageRoutes = accountInformationRoutes;
        break;
      default:
        break;
    }
    this.updatePublishedRoutes = _.chain(pageRoutes)
      .filter((route: any) => route.showUpdatePublished)
      .map((route: any) => route.path).value();
    this.ref.markForCheck();
  }

  private save(updateItems?: any) {
    this.informationPageService.emitSave({
      currentSegment: this.currentSegment,
      updateItems,
      isSaveBeforeLeaving: this.isSaveBeforeLeaving,
    });
    this.isSaveBeforeLeaving = false;
  }

  private updateSegments() {
    /*
      update segments based on current route,
      add permissions to them
    */
    const segments = this.route.snapshot.data.segments;
    this.segments = this.applyPermissions(this.route.snapshot.data.segments);
    /*
      update current segment value and set active tab
    */
    const url = this.route.snapshot.children[0].url[0];
    if (url) {
      this.currentSegment = url.path;
    } else {
      this.currentSegment = (this.pageRoute === 'global-brand-information') ?
       'product-groups' : 'profile';
    }

    // set segments nav margin left
    this.segmentsNavMarginLeft = 145;

    this.ref.markForCheck();
    _.delay(() => {
      if (this.segmentsNavigation) {
        this.segmentsNavigation.setActive(this.currentSegment);
      }
    }, 100);
  }

  private updateGlobalValidations() {
    this.globalValidationService.fetch(this.brandId)
    .subscribe(res => {
      if (this.segmentsNavigation) {
        this.segmentsNavigation.toggleCircles((segment: any) => {
          const error = _.get(res, `${segment.id}.error`, 0);
          return error ? true : false;
        });
      }
      this.ref.markForCheck();
    });
  }

  private updateRightNavs() {
    this.rightPanelNavs = _.filter(rightPanelNavs, (item: any) => {
      if (!item.disabledOn) { return true; }
      return !_.includes(item.disabledOn, this.currentSegment);
    });
    if (_.find(this.rightPanelNavs, ['name', 'comments'])) {
      this.setUnreadCommentsCount();
    }
    if (this.rightPanelNavs.length) {
      const tab = _.get(this.route.snapshot, 'children[0].params.tab', 'hints');
      _.defer(() => this.dynamicNavs && this.dynamicNavs.selectNav(tab));
    }
  }

  private subscribeNavsChange(): void {
    if (!this.dynamicNavs) {
      return;
    }
    this.dynamicNavs.changeNav
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((obj: any) => {
      if (obj.nav.name === 'comments') {
        obj.componentRef.instance.fetch(this.brandId, null, this.currentSegment);
        merge(
          obj.componentRef.instance.commentMarkedAsRead,
          obj.componentRef.instance.commentResolved
        )
          .pipe(takeWhile(() => obj.componentRef.instance.isActive))
          .subscribe(() => {
            this.setUnreadCommentsCount();
          });
      }
    });
  }

  private setUnreadCommentsCount(): void {
    this.commentsService.getUnreadCount(this.brandId, this.currentSegment)
    .subscribe((data: any) => {
      setUnreadCommentsCount(this.rightPanelNavs, data.count);
      this.ref.markForCheck();
    });
  }
}
